import React, { useMemo } from 'react';
import { LinkOnComponent } from 'app/components/links/link';
import { COLORS, Typography } from '@fupa/fupa-uikit';
import styled from 'styled-components';
import { MatchFilter } from 'app/routes/matchCalendar/types/MatchFilter';
import useDistrictUrls from 'app/hooks/useDistrictUrls';
const FooterWrapper = styled.div.withConfig({
  componentId: "sc-17tbqff-0"
})(["display:flex;justify-content:flex-end;align-items:center;"]);
const FooterLink = styled.div.withConfig({
  componentId: "sc-17tbqff-1"
})(["display:flex;width:fit-content;padding:0.5rem 1rem;background-color:", ";border:1px solid ", ";border-radius:4px;text-transform:uppercase;"], COLORS.white, COLORS.lightGrey);
export default function SeoFooter(_ref) {
  let {
    districtSlug,
    activeFilter,
    date
  } = _ref;
  const isToday = useMemo(() => !date || (date === null || date === void 0 ? void 0 : date.isToday()), [date]);
  const {
    districtMatchesUrl,
    districtMatchesCancelledUrl,
    districtMatchesLiveUrl
  } = useDistrictUrls(districtSlug);
  const dateQuery = date && isToday ? "?date=".concat(date.formatDateSlug()) : '';
  const linkRel = isToday ? 'follow' : 'nofollow';
  if (activeFilter === MatchFilter.Cancelled || activeFilter === MatchFilter.Live) {
    return /*#__PURE__*/React.createElement(FooterWrapper, null, /*#__PURE__*/React.createElement(FooterLink, null, /*#__PURE__*/React.createElement(LinkOnComponent, {
      rel: linkRel,
      to: "".concat(districtMatchesUrl).concat(dateQuery)
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "button-sub"
    }, "Zeige alle Spiele an"))));
  }
  return /*#__PURE__*/React.createElement(FooterWrapper, {
    "data-sentry-element": "FooterWrapper",
    "data-sentry-component": "SeoFooter",
    "data-sentry-source-file": "SeoFooter.tsx"
  }, /*#__PURE__*/React.createElement(FooterLink, {
    "data-sentry-element": "FooterLink",
    "data-sentry-source-file": "SeoFooter.tsx"
  }, /*#__PURE__*/React.createElement(LinkOnComponent, {
    rel: linkRel,
    to: "".concat(districtMatchesCancelledUrl).concat(dateQuery),
    "data-sentry-element": "LinkOnComponent",
    "data-sentry-source-file": "SeoFooter.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "button-sub",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "SeoFooter.tsx"
  }, "Zeige nur abgesagte Spiele an"))), /*#__PURE__*/React.createElement(FooterLink, {
    "data-sentry-element": "FooterLink",
    "data-sentry-source-file": "SeoFooter.tsx"
  }, /*#__PURE__*/React.createElement(LinkOnComponent, {
    rel: linkRel,
    to: "".concat(districtMatchesLiveUrl).concat(dateQuery),
    "data-sentry-element": "LinkOnComponent",
    "data-sentry-source-file": "SeoFooter.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "button-sub",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "SeoFooter.tsx"
  }, "Zeige nur Live-Spiele an"))));
}